import SyncListPageStore from './SyncListPageStore'

export default SyncListPageStore
